import { isNil, isEmpty } from 'ramda';

const isNilOrEmpty = val => isNil(val) || isEmpty(val);
const getKey = (item, index) => item && typeof item.id !== 'undefined' ? item.id : index.toString();
const randomString = () => Math.random().toString(36).substring(2, 15);
const randomStringOfLength = function () {
  let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
  let output = '';
  do {
    output += randomString();
  } while (output.length <= length);
  return output.substring(0, length);
};
const encodeMessageString = val => {
  return encodeURIComponent(window.btoa(val));
};
const decodeMessageString = val => {
  return window.atob(decodeURIComponent(val));
};

export { decodeMessageString, encodeMessageString, getKey, isNilOrEmpty, randomString, randomStringOfLength };
//# sourceMappingURL=stringUtils.js.map
